/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../../../components/UI'
import {FC, useEffect, useState} from 'react'
import {KTCard, KTSVG} from '../../../../../../../../../../_metronic/helpers'
import {LegalRepresentativeModel} from '../../../../../../model'
import {deleteLegalRepresentative, getLegalRepresentative} from '../../../../../../services'
import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import {ModalAddLegalRepresentative} from '../modal/ModalAddLegalRepresentative'
import Swal from 'sweetalert2'
import {ShowSnackBar} from '../../../../../../../../util/functions'
const TableLegalRepresentative: FC = () => {
  const {data, setData, setPagination, loading, setLoading, clearSelected, selectedOn, pagination} =
    useKTable()
  const {currentTabItem, isAllowed} = useLavanderia()
  const [showModalNew, setShowModalNew] = useState(false)
  const [legalRepToEdit, setLegalRepToEdit] = useState<LegalRepresentativeModel | any>(null)
  const [createdModal, setCreatedModal] = useState(false)

  const getLegalRepresentatives = async () => {
    try {
      clearSelected()
      setLoading(true)
      const {data: response} = await getLegalRepresentative(
        {
          proveedorId: currentTabItem.idToEdit,
        },
        pagination.currentPage,
      )
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const handleEdit = (item: LegalRepresentativeModel) => {
    setCreatedModal(false)
    setLegalRepToEdit(item)
    setShowModalNew(true)
  }
  useEffect(() => {
    getLegalRepresentatives()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    getLegalRepresentatives()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  const columns: Column<LegalRepresentativeModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} />,
      id: 'selection',
      Cell: ({...props}) => <KTableSelectionCellNonMultiple id={props.data[props.row.index].id} />,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo. Doc.' />,
      accessor: 'tipoDocumento',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nro. Doc.' />,
      accessor: 'numeroDocumento',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nombres' />,
      accessor: 'nombres',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Apellidos' />,
      accessor: 'apellidoPaterno',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Celular' />,
      accessor: 'celular',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Email' />,
      accessor: 'email',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cargo' />,
      accessor: 'cargo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Interlocutor' />,
      accessor: 'esInterlocutor',
      Cell: ({...props}) => <div>{props.row.original.esInterlocutor ? 'SI' : 'NO'}</div>,
    },

    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <>
          {isAllowed('REPRESENTANTELEGAL/EDITAR') && (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleEdit(props.row.original)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          )}
        </>
      ),
    },
  ]

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        const itemToDelete = selectedOn[0] || null
        // setLoading(true)
        const {data: response} = await deleteLegalRepresentative(itemToDelete)
        if (!response.error) {
          ShowSnackBar('Se eliminó satisfactoriamente')
          getLegalRepresentatives()
        } else {
          ShowSnackBar(response.message, 'error')
        }
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const handleNew = () => {
    setShowModalNew(true)
    setCreatedModal(true)
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='d-flex justify-content-end p-2 me-5'>
          {isAllowed('REPRESENTANTELEGAL/AGREGAR') && (
            <button type='button' className='btn btn-success me-3' onClick={handleNew}>
              Agregar
            </button>
          )}
          {isAllowed('REPRESENTANTELEGAL/ELIMINAR') && (
            <button
              type='button'
              className='btn btn-primary me-3'
              disabled={selectedOn.length < 1}
              onClick={handleDelete}
            >
              Eliminar
            </button>
          )}
        </div>
        {isAllowed('REPRESENTANTELEGAL/LISTAR') && (
          <>
            <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
            {loading ? <KTableLoading title='Cargando...' /> : null}
          </>
        )}

        {showModalNew ? (
          <ModalAddLegalRepresentative
            show={showModalNew}
            legalRepToEdit={legalRepToEdit}
            setShow={setShowModalNew}
            getLegalRepresentatives={getLegalRepresentatives}
            created={createdModal}
          />
        ) : (
          <></>
        )}
      </KTCard>
    </>
  )
}

const TableLegalRepresentativeWrapper = () => {
  return (
    <KTableProvider>
      <TableLegalRepresentative />
    </KTableProvider>
  )
}
export {TableLegalRepresentativeWrapper}
